import React__default from 'react';
import { ListboxSection, ListboxOption, Typography } from '@vp/swan';

const incompatibleMessage = (i18n) => {
    return [
        React__default.createElement(ListboxSection, null,
            React__default.createElement(ListboxOption, { textValue: "dummy-message", key: "dropdown-option-incompatible-option-msg", disabled: true },
                React__default.createElement(Typography, { fontWeight: "bold" },
                    " ",
                    i18n("incompatibilityMessage"),
                    " "))),
    ];
};

export { incompatibleMessage };
//# sourceMappingURL=incompatible-message.mjs.map
